module.exports = __webpack_public_path__ + "img/renewal-card.f37f6469.svg";